import { Button, Grid, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React from "react";
import NewRegistrationDialog from "../../UserPages/Dashboard/NewRegistrationDialog";

export default function AdminPaperRegistration() {
  const [showNewRegistrationDialog, setShowNewRegistrationDialog] = React.useState(true);
  return (
    <>
      <Grid style={{ textAlign: "center", marginTop: "2rem" }}>
        <Typography variant="h2">Paper Registration</Typography>
      </Grid>
      <Grid style={{ textAlign: "center", marginTop: "1.5rem" }}>
        <Button color="primary" variant="contained" size="large" onClick={() => setShowNewRegistrationDialog(true)}>
          <Add style={{ marginRight: 8 }} /> Add new paper registration
        </Button>

        <NewRegistrationDialog
          open={showNewRegistrationDialog}
          includeAdultAdoptee={true}
          isPaperRegistration={true}
          onClose={() => setShowNewRegistrationDialog(false)}
        />
      </Grid>
    </>
  );
}
